export const FILTER_KEYS = {
  apartment: 'apartment',
  street: 'street',
  city: 'city',
  region: 'region',
  counter: 'counter',
  house: 'house',
  serviceType: 'serviceType',
  status: 'status',
  taskLocationCode: 'taskLocationCode',
  workerUid: 'workerUid',
  contractNumber: 'contractNumber',
} as const;
